import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Route } from '@angular/compiler/src/core';
import { CookieService } from 'ngx-cookie-service';
import { OrderService } from 'src/app/services/orders.service';
import { OrderDto } from 'src/app/models/OrderDto';

@Component({
  selector: 'app-billing-address',
  templateUrl: './billing-address.component.html',
  styleUrls: ['./billing-address.component.scss']
})
export class BillingAddressComponent implements OnInit {
  // object = {
  //   name: 'Ritvik%20Khanijo%0A',
  //   address: '15%2F34%20A-10233%20Block-7A%20Some%20Place%2C%20New%20Delhi%2C%20Delhi%20110094',
  //   phone: ' 8899889988%0A',
  //   alt:'0099009900%0A',
  //   landmark: 'Near%20railway%20hospital',
  //   product: '%20Onelap%20micro%201%20year%20with%20sim%20card',
  //   isFast:'true'
  // }

  info = {
    name: '',
    address:'',
    phone:'',
    alt:'',
    landmark:'',
    product:'',
    isFast: false,
    products: [],
    mrp:'',
    offered:'',
    coupon:'',
    delivery:'',
    grandTotal:'',
    city:'',
    state:'',
    pincode:''
  };
  constructor(
    private activatedRoute : ActivatedRoute,
    private _cookie: CookieService,
    private order: OrderService,
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(params=>{
      var id = params.orderNumber;
      this._cookie.set("orderNumber",params.orderNumber);
      this.order.getOrder(id, "Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiI5ODExMDcxMzI3IiwiZXhwIjoxNjAwMTU5ODUwfQ.hPPprYxnU4Ju6nu_vm0J2-5_a-o57TMzlZz5SvlP8uyjBL804_PlklxKTAsjY7C39MJk-tofvVaPBY32Mt8Mxw").subscribe((data:OrderDto)=>{
        this.info.name = data.billingAddress.name;
        this.info.address = data.billingAddress.address;
        this.info.phone = data.billingAddress.contactNumber;
        this.info.alt = data.billingAddress.alternateContactNumber;
        this.info.landmark = data.billingAddress.landmark;
        this.info.isFast = data.isFastDeliveryApplied;
        this.info.mrp = JSON.stringify(data.mrpValue)
        this.info.offered = JSON.stringify(data.offeredValue);
        this.info.coupon = JSON.stringify(data.couponValue)
        this.info.delivery = JSON.stringify(data.deliveryCharge);
        this.info.grandTotal = JSON.stringify(data.cartFinalValue);
        this.info.pincode = data.billingAddress.pincode;
        this.info.state = data.billingAddress.state;
        this.info.city = data.billingAddress.city
        for(var i=0;i<data.products.length;i++){
          this.info.products[i] = data.products[i];
        }
      })
    })
    // this.info.name = decodeURIComponent(this.activatedRoute.snapshot.queryParams.name);
    // this.info.address = decodeURIComponent(this.activatedRoute.snapshot.queryParams.address);
    // this.info.phone = decodeURIComponent(this.activatedRoute.snapshot.queryParams.contactNumber);
    // this.info.alt = decodeURIComponent(this.activatedRoute.snapshot.queryParams.alternateNumber?this.activatedRoute.snapshot.queryParams.alternateNumber:'');
    // this.info.landmark = decodeURIComponent(this.activatedRoute.snapshot.queryParams.landmark?this.activatedRoute.snapshot.queryParams.landmark:'');
    // this.info.product = decodeURIComponent(this.activatedRoute.snapshot.queryParams.product);
    // this.info.isFast = decodeURI(this.activatedRoute.snapshot.queryParams.isFast)
  }

}
